import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import withApollo from 'next-with-apollo';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/client';
import { jsx as _jsx } from "react/jsx-runtime";
export default withApollo(function (_ref) {
  var initialState = _ref.initialState;
  return client(initialState);
}, {
  render: function render(_ref2) {
    var Page = _ref2.Page,
        props = _ref2.props;
    props.hideHeader = true;
    return /*#__PURE__*/_jsx(ApolloProvider, {
      client: props.apollo,
      children: /*#__PURE__*/_jsx(Page, _objectSpread({}, props))
    });
  }
});